import {
  UPDATE_USER_ID_NAME,
  UPDATE_USER_NAME,
  UPDATE_USER_ROLE,
  UPDATE_USER_TIME_FORMAT,
} from './user.constants';

export const updateUserRole = (userRoles) => {
  return (dispatch) => {
    const roles = userRoles.map((role) => role.name);
    dispatch({ type: UPDATE_USER_ROLE, payload: roles });
  };
};

export const updateUserName = (name) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_USER_NAME, payload: name });
  };
};

export const updateUserTimeFormat = (timeFormat) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_USER_TIME_FORMAT, payload: timeFormat });
  };
};

export const updateUserIdAndName = (name, id) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_USER_ID_NAME,
      payload: { name, id },
    });
  };
};
